import debounce from 'lodash/debounce'

// Controlling the curved SVG shape attributes to better match the designs
// for mobile/desktop screens
(function($) {
    const curve = $('.icon--about-curve-bg svg')

    if (!curve.length) {
        return false
    }

    const initialValue = curve[0].getAttribute('preserveAspectRatio')
    window.addEventListener('resize', debounce(onWindowResize, 100))
    onWindowResize()

    function onWindowResize() {
        const currentValue = curve[0].getAttribute('preserveAspectRatio')
        const newValue = window.innerWidth >= 2100 ? 'none' : initialValue

        // early exit
        if (newValue === currentValue) {
            return false
        }

        curve[0].setAttribute('preserveAspectRatio', newValue)
    }
})(jQuery)
